export const DEFAULT_COMPANY_CONFIG = {
	'name': 'Jubilant Elderly Care Tung Tau Estate',
	'url': 'https://jubilant2.sparkscreation.com.hk',
	'logo': '/assets/img/logo.png',
	'bg': '/assets/img/bg.jpg',
  'serial_no': 'SYS-01'
}
